import { RFIDCardDetails } from './../model/rfid-card.model';
import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Identity } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { RFIDCard } from '../model/rfid-card.model';

@Injectable({
    providedIn: 'root'
  })
  export class RFIDCardService {

    constructor(private tmcHttpService: HttpService) { }

    getRFIDCards(): Observable<RFIDCard[]> {
      return this.tmcHttpService.postWithContext<RFIDCard[]>(environment.rfidCardAdminEndpoint, {});
    }

    getRFIDCardDetails(identity: Identity): Observable<RFIDCardDetails> {
      return this.tmcHttpService.postWithContext<RFIDCardDetails>(environment.rfidCardAdminEndpoint + '/details', identity);
    }

    saveRFIDCard(RFIDCard: RFIDCardDetails): Observable<ServiceResponse> {
      return this.tmcHttpService.postWithContext<ServiceResponse>(environment.rfidCardAdminEndpoint + '/save', RFIDCard);
    }

    createRFIDCard(RFIDCard: RFIDCardDetails): Observable<ServiceResponse> {
      return this.tmcHttpService.postWithContext<ServiceResponse>(environment.rfidCardAdminEndpoint + '/create', RFIDCard);
    }

    deleteRFIDCard(identity: Identity): Observable<ServiceResponse> {
      return this.tmcHttpService.postWithContext<ServiceResponse>(environment.rfidCardAdminEndpoint + '/delete', identity);
    }
  }
